export default __webpack_public_path__ + "static/media/voyage.c053b7dc.svg";